import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-toaster-container',
    imports: [ToastModule],
    providers: [MessageService],
    template: `<p-toast position="top-right" />`,
    styles: []
})
export class ToasterContainerComponent {}
